// React
import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import { Name, Checkbox, CheckboxContainer, Price, ServiceContainer } from './styles'
import Input from 'ui/elements/Input'
import Label from 'ui/elements/Label'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons'

// Shared
import { fetchPrices } from 'shop-components/redux/actions/price'
import { money } from 'shared/utils/format'
import CartActions from 'store/v2/redux/actions/cart'
import { Settings as SettingsUtils } from 'back_office/v2/utils/utils'

const Service = ({ cart, service, fetchPrice, toggleService, dates, inCart, price, currency, hasPrice }) => {
  const [checked, setChecked] = useState(inCart)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (service?.id && cart?.id) {
      fetchPrice({ id: service.id, cartId: cart.id })
    }
  }, [dates.start, dates.stop, service?.id, cart?.id])

  useEffect(() => {
    if (inCart !== checked) {
      setChecked(inCart)
    }
  }, [inCart, checked])

  const handleToggleService = useCallback(() => {
    const value = !checked

    setLoading(true)
    setChecked((prev) => !prev)

    toggleService({ id: service.id, value })
      .catch(() => {
        setChecked((prev) => !prev)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [checked, service?.id])

  if (!service) return null

  return (
    <ServiceContainer hasPrice={price && hasPrice}>
      <Label htmlFor={service.id} modifiers="no-margin">
        <CheckboxContainer>
          <Input
            id={service.id}
            type="checkbox"
            value={checked}
            checked={checked}
            onChange={handleToggleService}
            disabled={loading}
          />
          <Checkbox>
            <FontAwesomeIcon icon={farCheck} />
          </Checkbox>
        </CheckboxContainer>
      </Label>
      <Name disabled={!checked}>
        <Label htmlFor={service.id}>{service.name}</Label>
      </Name>
      {price && hasPrice && <Price disabled={!checked}>{money(price.price_each_in_cents, currency)}</Price>}
    </ServiceContainer>
  )
}

Service.propTypes = {
  service: PropTypes.object,
  cart: PropTypes.object,
  fetchPrice: PropTypes.func,
  toggleService: PropTypes.func,
  dates: PropTypes.object,
  price: PropTypes.object,
  currency: PropTypes.object,
  inCart: PropTypes.bool,
  hasPrice: PropTypes.bool
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId)
  const dates = { start: cart?.starts_at, stop: cart?.stops_at }

  const price = state.items.records[props.service?.product_group_id]?.price
  const currency = window.booqableOptions.currency

  const hasPrice =
    price?.price_each_in_cents >= 0 &&
    price?.price_each_in_cents !== null &&
    props.service?.price_type !== 'none' &&
    props.service?.price_type !== null &&
    SettingsUtils.get('store.use_prices')

  return { dates, cart, price, currency, hasPrice }
}

const mapDispatchToProps = (dispatch, props) => {
  const book = ({ id, quantity }) =>
    CartActions.book({
      item_id: id,
      quantity,
      type: 'set'
    })

  return {
    fetchPrice: (params) => dispatch(fetchPrices(params)),
    toggleService: ({ id, value }) => {
      if (value) {
        return book({ id, quantity: 1 })
      } else {
        return book({ id, quantity: 0 })
      }
    }
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Service)
